import { all, takeLatest, put, call } from 'redux-saga/effects';
import { request } from '../../utils/http';

import { getSimplifiedError } from '../../utils/error';
import {
  GET_SURVEY_ERROR,
  GET_SURVEY_REQUEST,
  GET_SURVEY_SUCCESS,
  SAVE_ANSWER_ERROR,
  SAVE_ANSWER_REQUEST,
  SAVE_ANSWER_SUCCESS,
} from '../reducers/SurveyReducer';

function getSurveys() {
  return request.get('/survey/get-survey/');
}

function* handleGetSurveys() {
  try {
    const { data } = yield call(getSurveys);
    yield put({
      type: GET_SURVEY_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: GET_SURVEY_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function saveAnswer(payload) {
  return request.post('/survey/answer-question/', payload);
}

function* handleSaveAnswer({ payload }) {
  try {
    const { data } = yield call(saveAnswer, payload);
    yield put({
      type: SAVE_ANSWER_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: SAVE_ANSWER_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

export default all([
  takeLatest(GET_SURVEY_REQUEST, handleGetSurveys),
  takeLatest(SAVE_ANSWER_REQUEST, handleSaveAnswer),
]);
